<template>
  <img v-if="qrUrl" :src="qrUrl" alt="QRコード" />
</template>

<script setup>
import QRCode from 'qrcode'

const qrUrl = ref('')

const pageUrl = computed(() => {
  return location.href ? location.href : ''
})

const generateQRCode = () => {
  if (pageUrl.value) {
    QRCode.toDataURL(pageUrl.value, (err, url) => {
      if (err) {
        throw err
      }
      qrUrl.value = url
    })
  }
}

onMounted(() => {
  generateQRCode()
})
</script>

<style lang="scss" scoped>
img {
  width: 100%;
}
</style>
